import React from "react";
import { Spin } from "antd";

const PageSpinner = (size = "large", fullPage = false) => (
  <div className={`spinner__wrapper ${fullPage ? "fullscreen" : ""}`}>
    <Spin size={size} />
  </div>
);

export default PageSpinner;
